var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconExclamation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 23,
    viewBox: "0 0 6 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.09012 3.05122C1.01095 1.94281 1.88882 1 3.00006 1C4.11129 1 4.98916 1.94281 4.90999 3.05122L4.10154 14.3696C4.06026 14.9474 3.57941 15.3952 3.00006 15.3952C2.4207 15.3952 1.93985 14.9474 1.89857 14.3696L1.09012 3.05122Z",
    fill: "#E34646",
    stroke: "#E34646",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.62904 18.1371C0.871875 18.8943 0.871875 20.1219 1.62904 20.879C2.3862 21.6362 3.61381 21.6362 4.37098 20.879C5.12814 20.1219 5.12814 18.8943 4.37098 18.1371C3.61381 17.3799 2.3862 17.3799 1.62904 18.1371Z",
    fill: "#E34646"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExclamation);
export default __webpack_public_path__ + "static/media/icon_exclamation.b3a2c24cfd21e368363cdc9d4c3b63c9.svg";
export { ForwardRef as ReactComponent };